module.exports = {
	"art": "Arts",
	"ant": "Antiques",
	"col": "Collectibles & Memorabilia",
	"tec": "Computers & Electronics",
	"jgw": "jewelry, Gemstones & Watches",
	"cai": "Commercial & Industrial",
	"bac": "Benefit & Charity",
	"eab": "Equine & Cattle",
	"fhi": "Furniture & Household items",
	"veh": "Vehicles",
	"hvy": "Heavy Equipment",
	"fme": "Farm Machinery",
	"rei": "Real Estate",
	"gov": "Government",
	"undefined": "No category"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/categories.json5
// module id = 1921
// module chunks = 6